export default __webpack_public_path__ + "static/media/app_screen_profile.f7056858.png";